import { BsbDirectoryScreen } from '../features/bsbDirectory/BsbDirectoryScreen';

export const BsbVerificationPage = () => <BsbDirectoryScreen />;
